class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement{
  constructor() {
    super()
    this.header = document.querySelector('.header-wrapper');
    if (this.dataset.type == "mega-menu") this.initMegaMenuEvents()
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  initMegaMenuEvents(){
    this.secondLevelLinks = this.querySelectorAll(".second-level-menu")
    this.linkCollectionProducts = this.querySelectorAll(".menu-collection-products")
    this.thirdLevelLinks = this.querySelectorAll(".third-level-menu")
    this.secondLevelLinks.forEach(link => {
      link.addEventListener("mouseenter", this.mouseEnterSecondLink.bind(this, link))
    })
  }
  mouseEnterSecondLink(secondLink){
    this.secondLevelLinks.forEach(link => link.classList.remove("active"))
    secondLink.classList.add("active")
    this.thirdLevelLinks.forEach(link => link.classList.add("hidden"))
    Array.from(this.thirdLevelLinks).find(link => link.dataset.collectionHandle == secondLink.dataset.collectionHandle)?.classList.remove("hidden")
    this.linkCollectionProducts.forEach(products => products.classList.add("hidden"))
    Array.from(this.linkCollectionProducts).find(products => products.dataset.collectionHandle == secondLink.dataset.collectionHandle)?.classList.remove("hidden")
  }
  close() {}
}

customElements.define('header-menu', HeaderMenu);
